export default "__VITE_ASSET__DmBgZR4t__"